module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "font-size-control list-group"
  }, _vm._l((_vm.content), function(phrase, phraseIndex) {
    return (phrase.name) ? _c('li', {
      key: phraseIndex,
      staticClass: "list-group-item text-left"
    }, [_c('div', {
      staticClass: "title w-100 pl-3",
      on: {
        "click": function($event) {
          _vm.play(phrase)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-volume-up"
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(phrase.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "w-100 pl-3"
    }, [(phrase.content) ? _c('p', {
      staticClass: "pre",
      domProps: {
        "innerHTML": _vm._s(phrase.content)
      }
    }) : _vm._e(), _vm._v(" "), (phrase.content_result) ? _c('p', _vm._l((phrase.content_result), function(part, partIndex) {
      return _c('span', {
        key: partIndex
      }, [(part.audio) ? _c('span', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.play({
              name: '',
              audio: part.audio
            })
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-volume-up"
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(part.text)
        }
      })]) : _c('span', {
        staticClass: "pre",
        domProps: {
          "innerHTML": _vm._s(part.text)
        }
      })])
    }), 0) : _c('p', {
      staticClass: "pre",
      domProps: {
        "innerHTML": _vm._s(phrase.content_i18N[0].value)
      }
    }), _vm._v(" "), (phrase.example) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(phrase.example)
      }
    }) : _vm._e()])]) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49bb5e89!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/Phrases.vue
// module id = 721
// module chunks = 1